import { mapActions } from "vuex";
import moment from "moment";
import _ from "lodash";
export default {
    name: "orderProcess",
    data() {
        return {
            permissions: {
                order_deal_query: false
            },
            checkpictureVisible: false,
            loading: false,
            exportLoading:false,
            vehicleMap: [{
                "plVehicleType": "厢式",
                "plVehicleCode": "300",
                "grdVehicleCode": "002001"
            },
            {
                "plVehicleType": "平板",
                "plVehicleCode": "350",
                "grdVehicleCode": "002007"
            },
            {
                "plVehicleType": "高栏",
                "plVehicleCode": "450",
                "grdVehicleCode": "002024"
            },
            {
                "plVehicleType": "特种运输",
                "plVehicleCode": "600",
                "grdVehicleCode": "002025"
            },
            {
                "plVehicleType": "封闭式一体货车/客车",
                "plVehicleCode": "100",
                "grdVehicleCode": "002016"
            },
            {
                "plVehicleType": "冷藏车",
                "plVehicleCode": "900",
                "grdVehicleCode": "002013"
            }],
            SFMap: window.SFMap,
            mode: '1',
            form: {
                orderId: '',
                src: '',
                dest: '',
                createTm:[],
                start: '',
                end: '',
                pageNum: 1,
                pageSize: 10,
                processType: '',
                processStatus: '',
            },
            total: 0,
            tabs: {
                activeName: '',
                label: '全部',
                label1: '待接单',
                label2: '待装货',
                label3: '运输中',
                label4: '待收货',
                label5: '已取消',
                label10: '已完成',
                label9: '已中止',
            },
            table: [],
            detail: {
                map: {
                    mapIns: '',
                    polyline: '',
                    pointLayer: null,
                    planLayer: [],
                    carLayer: [],
                    phoneLayer: [],
                    truckMainCoordinate: [],
                    planGPS: false,
                    carGPS: false,
                    phoneGPS: false,
                    coordinates: [],
                    planCoordinates: [],
                    carCoordinates: [],
                    phoneCoordinates: [],
                },
                order: {
                    title: '-'
                    , status: {
                        status: true,
                        status1: false,
                        status2: false,
                        status3: false,
                    }
                    , remainTm:'-'
                    , processReasonComment:'-'
                    , state: ''
                    , statusName: ''
                    , orderId: ''
                    , planArriveTm: ''
                    , reachTm: ''
                    , totalPrice: ''
                    , needReceipt: ''
                    , needReceiptImg: ''
                    , needReceiptSrc: ''
                    , dataOwner: ''
                    , distance: ''
                    , runTm: ''
                    , cargoInfo: ''
                    , cargoWeight: ''
                    , cargoVolume: ''
                    , mode: ''
                    , carType: ''
                    , vehicleType: ''
                    , vehicleLength: ''
                    , comment: ''
                    , priceRule: ''
                    , price: ''
                    , saasPassZoneDtos: []
                    , orderChangeItemDtos: []
                    , opLogs: []
                    , srcCity: ''
                    , vehicleSerial: ''
                    , taskId: ''
                    , deductionInfoResponses:[]
                },
                table: [],
                logData: [],
            },
            orderDetailVisible: false,
            cancelVisible: false,
            progress: 0,
            cancelForm: {
                rules: {
                    deleteReason: [{ required: true, message: "请选择取消原因", trigger: "change" }]
                },
                orderId: '',
                deleteReason: '',
                deleteReasonDesc: '',
            }
        }
    },
    methods: {
        ...mapActions([
            'getOrderListApi',
            'exportApi',
            'getOrderDetailApi',
            'cancelOrderApi',
            'ensureOrderApi',
            'queryReceiptApi',
            'queryTrackApi',
            'getProcessListApi',
            'getProcessDetailApi',
        ]),
        mapProcessStatus(processStatus){
            let name = '';
            switch(processStatus){
                case 'P11': name = '待司机确认' ;break;
                case 'P12': name = '已生效' ;break;
                case 'P13': name = '已驳回' ;break;
                case 'P14': name = '已取消' ;break;
                default: name = '' ;break;
            }
            return name
        },
        mapOrderState(orderState){
            let stateName = ''
            switch (orderState) {
                case 0: stateName = '全部'; break;
                case 1: stateName = '待接单'; break;
                case 2: stateName = '待装货'; break;
                case 3: stateName = '运输中'; break;
                case 4: stateName = '待收货'; break;
                case 5: stateName = '已取消'; break;
                case 10: stateName = '已完成'; break;
                case 11: stateName = '待结算'; break;
                case 9: stateName = '已中止'; break;
                default: stateName = '-'; break;
            }
            return stateName
        },
        mapProcessType(processType){
            let name = '';
            switch(processType){
                case 'P1': name = '订单修改' ;break;
                default: name = '-' ;break;
            }
            return name
        },
        getProcessList(){
            let params = Object.assign({}, this.form)
            this.table = []
            this.loading = true
            if (params.createTm.length > 0) {
                params.start = params.createTm[0] + ' 00:00:00'
                params.end = params.createTm[1] + ' 23:59:59'
            }
            delete params.createTm
            this.getProcessListApi(params).then(res => {
                this.table = res.list;
                this.total = res.total;

            }).catch(e => { }).finally(() => {
                this.loading = false
            });
        },
        geneDetails(row){
            let desc = row.desc?row.desc:'-'
            let comment = row.comment?row.comment:'-'
            let emtpy = "&nbsp;&nbsp;&nbsp;"
            return desc + emtpy + comment
        },
        
        onCheckPicture() {
            if (this.detail.order.needReceiptSrc) {
                this.checkpictureVisible = true;
            }
        },
        queryReceipt() {
            let params = {
                orderId: this.detail.order.orderId,
                srcCity: this.detail.order.srcCity
            }
            this.queryReceiptApi(params).then(res => {
                let photo = res.photoPath
                if (photo) {
                    this.detail.order.needReceiptImg = '<img title="点击放大" src="' + photo + '">'
                    this.detail.order.needReceiptSrc = photo
                } else {
                    this.detail.order.needReceiptImg = '-'
                }

            }).catch(e => { })
        },
        queryTrack() {
            let params = {
                taskId: this.detail.order.taskId,
                vehicleSerial: this.detail.order.vehicleSerial,
                trucksOnly: 1
            }
            this.queryTrackApi(params).then(res => {
                /* let arr0 = JSON.parse(res.truckMainCoordinate)
                let newarr0 = []
                arr0.forEach(item => {
                    newarr0.push([item[1], item[0]])
                })
                let arr1 = JSON.parse(res.truckMainCoordinate)
                let newarr1 = []
                arr1.forEach(item => {
                    newarr1.push([item[1], item[0]])
                }) */
                let passPoint = res.passCoordinateList
                if (passPoint.length > 0) {
                    passPoint.forEach(item=>{
                        item.reverse()
                    })
                    this.drawPoints(passPoint);
                }

                let arr2 = JSON.parse(res.phoneLatLng.result)
                let newarr2 = []
                arr2.forEach(item => {
                    newarr2.push([Number(parseFloat(item.zy).toFixed(6)), Number(parseFloat(item.zx).toFixed(6))])
                })

                /* this.detail.map.planCoordinates = newarr0
                this.detail.map.carCoordinates = newarr1 */
                this.detail.map.phoneCoordinates = newarr2
            }).catch(e => { })
        },
        onProgessChange(val) {
            let arr = this.detail.map.phoneCoordinates
            let i = parseInt(arr.length * val/100)
            if(arr.length>0){
                this.showSlidePosition(arr[i]);
            }
        },
        showSlidePosition(coordinate){
            let myIcon = this.SFMap.circleIcon({
                iconRadius: 100,                    
                backgroundColor: '#FF0033',          
                circleRadius: 10,                    
                boxShadow: '0 0 30px 5px #FF0033',   
                ripple: 2,                           
                rippleColor: '#FF0033',              
            });
            let  iconMarker = this.SFMap.marker(coordinate, {
                icon: myIcon
            });
            if(this.detail.map.vectorLayer){
                this.detail.map.vectorLayer.clear();
            }
            this.detail.map.vectorLayer.addLayer(iconMarker);
        },
        mapVehicle(code) {
            var name = ''
            this.vehicleMap.forEach(item => {
                code == item.plVehicleCode && (name = item.plVehicleType)
            })
            if(name == ''){
                name = code
            }
            return name
        },
        geneTmStr(m) {
            let days = moment.duration(m, 'minutes').days()
            let hours = moment.duration(m, 'minutes').hours()
            let minutes = moment.duration(m, 'minutes').minutes()
            return (days ? days : '-') + '天' + (hours ? hours : '-') + '时' + (minutes ? minutes : '-') + '分'
        },
        mapState(state) {
            let stateName = ''
            switch (state) {
                case 0: stateName = '全部'; break;
                case 1: stateName = '待接单'; break;
                case 2: stateName = '待装货'; break;
                case 3: stateName = '运输中'; break;
                case 4: stateName = '待收货'; break;
                case 5: stateName = '已取消'; break;
                case 10: stateName = '已完成'; break;
                case 9: stateName = '已中止'; break;
                default: stateName = '-'; break;
            }
            return stateName
        },
        clear(layer) {
            if (layer.length > 0) {
                layer[0].remove()
            }
        },
        planChange(val) {
            if (val) {
                this.clear(this.detail.map.planLayer)
                if (this.detail.map.planCoordinates.length > 0) {
                    this.draw(this.detail.map.planCoordinates, this.detail.map.planLayer, '#00bcd4', 10)
                }
            } else {
                this.clear(this.detail.map.planLayer)
            }
        },
        carChange(val) {
            if (val) {
                this.clear(this.detail.map.carLayer)
                if (this.detail.map.carCoordinates.length > 0) {
                    this.draw(this.detail.map.carCoordinates, this.detail.map.carLayer, '#1919fe')
                }
            } else {
                this.clear(this.detail.map.carLayer)
            }
        },
        phoneChange(val) {
            if (val) {
                this.clear(this.detail.map.phoneLayer)
                if (this.detail.map.phoneCoordinates.length > 0) {
                    this.draw(this.detail.map.phoneCoordinates, this.detail.map.phoneLayer, '#1919fe',7)
                }
            } else {
                this.clear(this.detail.map.phoneLayer)
            }
        },
        formatTm(remainingTime){
            let days = moment.duration(remainingTime, 'milliseconds').days()
            let hours = moment.duration(remainingTime, 'milliseconds').hours()
            let minutes = moment.duration(remainingTime, 'milliseconds').minutes()
            let seconds = moment.duration(remainingTime, 'milliseconds').seconds()
            return (days ? days : '-') + '天' + (hours ? hours : '-') + '时' + (minutes ? minutes : '-') + '分' + (seconds ? seconds : '-') + '秒'
        },
        onCheckDetail(orderId,version) {
            let params = {
                orderId: orderId,
                version: version
            }
            this.loading = true
            this.mode = '1'
            this.detail.order.needReceiptImg = ''
            this.detail.order.needReceiptSrc = ''
            this.getProcessDetailApi(params).then(res => {
                let obj = this.detail.order;
                let order = res.afterOrderInfoDto;
                obj.processStatus = res.processStatus;
                obj.dataOwner = order.dataOwner;
                obj.distance = order.distance;
                obj.runTm = order.runTm;
                obj.cargoInfo = order.cargoInfo;
                obj.cargoWeight = order.cargoWeight;
                obj.cargoVolume = order.cargoVolume;
                obj.outerOrderId = order.outerOrderId;
                obj.carType = order.carType;
                obj.vehicleType = order.vehicleType;
                obj.vehicleLength = order.vehicleLength;
                obj.carrierType = (order.carrierType == '1' ? '个人' : order.carrierType == '2' ? (order.childCarrierName ? order.childCarrierName : '') : '-')
                obj.driverName = order.driverName;
                obj.driverPhone = order.driverPhone;
                obj.vehicleSerial = order.vehicleSerial;
                obj.needReceipt = order.needReceipt;
                obj.receiptType = order.receiptType;
                obj.receiptName = order.receiptName;
                obj.receiptPhone = order.receiptPhone;
                obj.receiptAddress = order.receiptAddress;
                obj.comment = order.comment;
                obj.orderId = order.orderId;
                obj.priceRule = order.priceRule;
                obj.price = order.price;
                obj.totalPrice = order.totalPrice;
                obj.saasPassZoneDtos = order.saasPassZoneDtos;
                obj.orderChangeItemDtos = res.orderChangeItemDtos;

                obj.status.status1 = false
                obj.status.status2 = false
                obj.status.status3 = false
                if (res.processStatus == 'P11') {
                    obj.status.status1 = true
                    obj.remainTm = this.formatTm(res.remainingTime)
                } else if (res.processStatus == 'P12') {
                    obj.status.status3 = true
                } else if (res.processStatus == 'P13' ) {
                    obj.status.status2 = true
                    obj.processReasonComment = res.processReasonComment;
                } 

                this.orderDetailVisible = true;
            }).catch(e => { }).finally(() => {
                this.loading = false
            });
        },
        eCloseCancel() {
            this.$refs.cancelFormRef.resetFields();
        },
        onCancelOrder(row) {
            this.cancelForm.orderId = row.orderId
            this.cancelVisible = true
        },
        onCancelConfirm() {
            let params = {
                orderId: this.cancelForm.orderId
                , deleteReason: this.cancelForm.deleteReason
                , deleteReasonDesc: this.cancelForm.deleteReasonDesc
            }
            this.$refs.cancelFormRef.validate((valid) => {
                if (valid) {
                    this.cancelOrderApi(params).then(res => {
                        this.$message({
                            type: 'success',
                            message: '取消成功'
                        });
                        this.cancelVisible = false
                        this.getProcessList();
                    }).catch(e => { });
                }
            })

        },
        onAcceptOrder(row) {
            let params = {
                orderId: row.orderId
                , shippingState: 2
            }
            this.$confirm(`确定收货？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.ensureOrderApi(params).then(res => {
                    this.$message({
                        type: 'success',
                        message: '收货成功'
                    });
                    this.getProcessList();
                }).catch(e => { });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "取消确认",
                });
            });
        },
        drawPoints(coordinates) {
            if(this.detail.map.pointLayer){
                this.detail.map.pointLayer.clearLayers()  
            }
            let startMarker = this.SFMap.marker(coordinates[0], { iconIndex: 'start' });
            let endMarker = this.SFMap.marker(coordinates[coordinates.length - 1], { iconIndex: 'end' });
            let passMarker = [];
            for (let i = 1; i < coordinates.length - 1; i++) {
                passMarker.push(this.SFMap.marker(coordinates[i], { iconIndex: 'pass' }))
            }
            this.detail.map.pointLayer = this.SFMap.vectorLayer({ map: this.detail.map.mapIns, features: [startMarker,...passMarker, endMarker] });
        },
        draw(coordinates, layer, color, width) {
            let c = color ? color : "#3388ff"
            let tplLayer = this.SFMap.polyline(coordinates, {
                map: this.detail.map.mapIns,
                color: c,
                opacity: 1,
                weight: (width ? width : 3),
                showSymbol: true,
                symbol: [{
                    type: 'arrow',
                    repeat: 50,
                    offset: 15,
                    rotate: false,
                    color: '#ffffff',
                    symbol: undefined
                }]
            });
            layer[0] = tplLayer
            this.detail.map.mapIns.fitBounds(tplLayer.getBounds());
        },

        eOpenDetail() {

        },
        initMap() {
            if (!this.detail.map.mapIns) {
                this.detail.map.mapIns = this.SFMap.map("map", {
                    center: [22.524729, 113.940159],
                    zoom: 12
                });
                this.detail.map.vectorLayer = this.SFMap.vectorLayer({ map: this.detail.map.mapIns });

            }
        },
        onExport(){
            let params = Object.assign({}, this.form)
            this.exportLoading = true
            if (params.createTm.length > 0) {
                params.start = params.createTm[0] + ' 00:00:00'
                params.end = params.createTm[1] + ' 23:59:59'
            }
            params.orderState = this.tabs.activeName == 0 ? '' : this.tabs.activeName;

            delete params.createTm
            this.exportApi(params).then(res => {
                window.open(this.getHostUrl()+"/saas/orderCore/downLoadFile?objectName="+res.filePath)
            }).catch(e => { }).finally(() => {
                this.exportLoading = false
            });
        },
        getHostUrl(){
            return location.protocol + "//" + location.host ;
        },
        showDownload(url){
            let downloadbtn = `<a href="${url}">点击下载导出的Excel文件</a>`
            this.$alert(downloadbtn, '下载', {
                confirmButtonText: '取消',
                customClass:'css-alert',
                dangerouslyUseHTMLString: true,
                callback: action => {}
            });
        },
        onReset() {
            Object.assign(this.form, this.$options.data().form)
        },
        lineList(row) {
            return '<span class="point src"></span>' + row.srcAddr + '<br><span class="point dest"></span>' + row.destAddr
        },
        onSearch() {
            this.form.pageNum = 1;
            this.getProcessList();
        },
        onTabsClick() {
            this.form.pageNum = 1;
            this.getProcessList()
        },
        onSizeChange() { },
        onCurrentChange(val) {
            this.form.pageNum = val;
            this.getProcessList()
        },
        initMapData(){
            this.detail.map.phoneGPS = false;
            this.progress = 0;
            if(this.detail.map.phoneLayer.length > 0){
                this.clear(this.detail.map.phoneLayer)
            }
            if(this.detail.map.pointLayer){
                this.detail.map.pointLayer.clearLayers()  
            }

        },
        onToggleMode() {
            if (this.mode == '1') {
                this.mode = '2'
                this.initMapData();
                this.queryTrack();
                setTimeout(() => {
                    this.initMap()
                }, 0)
            } else {
                this.mode = '1'
            }
        }

    },
    watch: {

    },
    created(){
        this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
        let orderId = sessionStorage.getItem('alterOrderId')
        let version = sessionStorage.getItem('version')
        sessionStorage.removeItem('alterOrderId');
        sessionStorage.removeItem('version');
        if (orderId) {
            this.onCheckDetail(orderId,version)
        }
    },
    mounted() {
        this.getProcessList()
    }
}